import {
  HOST,
  USE_CDN,
  DEBUG_MODE,
  PRACTICAL_STREAM_CDN_ADDRESS,
} from './config'
import { isNotNullOrEmptyString, toTrimmedString } from './misc'

export async function getBusinessUserCredit(
  web2UserId: string,
  confirmationCode: string | null,
): Promise<any> {
  return new Promise<any>(async (resolve) => {
    let ret: any = null
    try {
      if (isNotNullOrEmptyString(web2UserId)) {
        const opts = {
          method: 'POST',
          body: JSON.stringify({
            web2UserId: web2UserId,
            confirmationCode: confirmationCode,
          }),
        }
        const x = await fetch(HOST + '/api/p.stream-sv/buc/gb', opts)
        ret = await x.json()
        resolve({
          success: ret?.success,
          businessUserCredit: ret?.businessUserCredit
            ? ret?.businessUserCredit
            : null,
        })
      } else resolve(null)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(null)
    }
  })
}

export async function postUserCreditLedgerEvent(
  web2UserId: string,
  referenceId: string,
  transactionType: string,
  amount: number,
): Promise<any> {
  return new Promise<any>(async (resolve) => {
    let ret: any = null
    try {
      if (
        isNotNullOrEmptyString(web2UserId) &&
        isNotNullOrEmptyString(transactionType) &&
        isNotNullOrEmptyString(referenceId)
      ) {
        const urlencoded: URLSearchParams = new URLSearchParams({
          userData: JSON.stringify({
            web2UserId: web2UserId,
            referenceId: referenceId,
            transactionType: transactionType,
            amount: amount,
          }),
        })
        const opts: any = {
          method: 'POST',
          body: urlencoded,
        }
        await fetch(HOST + '/api/p.stream-sv/buc/pb', opts)
          .then(async (x: any) => {
            let resp: any = await x.json()
            ret = {
              success: resp?.success ? true : false,
              businessUserCredit: resp?.businessUserCredit
                ? resp?.businessUserCredit
                : null,
            }
          })
          .catch((e: any) => {
            ret = e
            if (DEBUG_MODE) console.log(e)
          })
        return resolve(ret)
      } else resolve(null)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(null)
    }
  })
}

export async function prompt(prompt: string): Promise<any> {
  return new Promise<any>(async (resolve) => {
    let ret: any = null
    try {
      if (isNotNullOrEmptyString(prompt)) {
        const opts = {
          method: 'POST',
          body: JSON.stringify({
            prompt: prompt,
          }),
        }
        await fetch(HOST + '/api/p.stream-sv/a/p', opts)
          .then(async (x: any) => {
            ret = await x.json()
            ret = ret?.matches?.length > 0 ? ret?.matches : []
          })
          .catch((e: any) => {
            ret = e
            if (DEBUG_MODE) console.log(e)
          })
        return resolve(ret)
      } else resolve(null)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(null)
    }
  })
}

export async function extractBrandKeywords(
  url: string,
  lang: any,
): Promise<any> {
  return new Promise<any>(async (resolve) => {
    let ret: any = { keywords: [], vibe: '' }
    try {
      if (isNotNullOrEmptyString(url)) {
        const opts = {
          method: 'POST',
          body: JSON.stringify({
            url: url,
            lang: lang,
          }),
        }
        await fetch(HOST + '/api/p.stream-sv/a/s', opts)
          .then(async (x: any) => {
            ret = await x.json()
            if (DEBUG_MODE) console.log(ret)
            ret = {
              keywords: ret?.keywords,
              vibe: toTrimmedString(ret?.brand_vibe_summary),
            }
            resolve(ret)
          })
          .catch((e: any) => {
            ret = e
            if (DEBUG_MODE) console.log(e)
            resolve(ret)
          })
      } else resolve(ret)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(ret)
    }
  })
}

export const BEGINNING_USER_CREDITS_BALANCE: number = 25

export const MAXIMUM_MILLISECONDS_TO_CHECK_FOR_CREDITS_AFTER_PURCHASE: number = 30000
export const MILLISECONDS_INTERVAL_TO_CHECK_FOR_CREDITS_AFTER_PURCHASE: number = 2000

export const MINIMUM_CHARACTERS_FOR_A_REASONABLE_ANALYSIS_EN: number = 20
export const MINIMUM_CHARACTERS_FOR_A_REASONABLE_ANALYSIS_ES: number = 25
export const MINIMUM_CHARACTERS_FOR_A_REASONABLE_ANALYSIS_FR: number = 25
export const MINIMUM_CHARACTERS_FOR_A_REASONABLE_ANALYSIS_KO: number = 12

export const SMALL_VIEWPORT_VIDEO_POSTER_IMG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'EE2E04CA-9055-45A7-9868-81ADC23CA55E.jpg?v=1'
  : HOST + '/images/EE2E04CA-9055-45A7-9868-81ADC23CA55E.jpg'
export const SMALL_VIEWPORT_VIDEO_POSTER_IMG_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    'EE2E04CA-9055-45A7-9868-81ADC23CA55E.avif?v=1'
  : HOST + '/images/EE2E04CA-9055-45A7-9868-81ADC23CA55E.avif'
export const MEDIUM_VIEWPORT_VIDEO_POSTER_IMG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '7B09E68B-3553-4008-99A3-DB0219804DE0.jpg'
  : HOST + '/images/7B09E68B-3553-4008-99A3-DB0219804DE0.jpg'
export const MEDIUM_VIEWPORT_VIDEO_POSTER_IMG_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '7B09E68B-3553-4008-99A3-DB0219804DE0.avif'
  : HOST + '/images/7B09E68B-3553-4008-99A3-DB0219804DE0.avif'
export const BIG_VIEWPORT_VIDEO_POSTER_IMG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A5D58D8F-DC07-429E-A953-E6015B65C5CB.jpg'
  : HOST + '/images/A5D58D8F-DC07-429E-A953-E6015B65C5CB.jpg'
export const BIG_VIEWPORT_VIDEO_POSTER_IMG_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'A5D58D8F-DC07-429E-A953-E6015B65C5CB.avif'
  : HOST + '/images/A5D58D8F-DC07-429E-A953-E6015B65C5CB.avif'
export const SMALL_VIEWPORT_VIDEO_POSTER_IMG_LIGHT: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '213DCF7E-B2B1-4733-8130-E682143F7DA9.jpg?v=1'
  : HOST + '/images/213DCF7E-B2B1-4733-8130-E682143F7DA9.jpg'
export const SMALL_VIEWPORT_VIDEO_POSTER_IMG_AVIF_LIGHT: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS +
    '213DCF7E-B2B1-4733-8130-E682143F7DA9.avif?v=1'
  : HOST + '/images/213DCF7E-B2B1-4733-8130-E682143F7DA9.avif'
export const MEDIUM_VIEWPORT_VIDEO_POSTER_IMG_LIGHT: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '1ECA28DA-D1C9-45B5-8E45-565369962CD0.jpg'
  : HOST + '/images/1ECA28DA-D1C9-45B5-8E45-565369962CD0.jpg'
export const MEDIUM_VIEWPORT_VIDEO_POSTER_IMG_AVIF_LIGHT: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '1ECA28DA-D1C9-45B5-8E45-565369962CD0.avif'
  : HOST + '/images/1ECA28DA-D1C9-45B5-8E45-565369962CD0.avif'
export const BIG_VIEWPORT_VIDEO_POSTER_IMG_LIGHT: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '96999C34-86E5-4C9D-8522-57A22DDCAC5F.jpg'
  : HOST + '/images/96999C34-86E5-4C9D-8522-57A22DDCAC5F.jpg'
export const BIG_VIEWPORT_VIDEO_POSTER_IMG_AVIF_LIGHT: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '96999C34-86E5-4C9D-8522-57A22DDCAC5F.avif'
  : HOST + '/images/96999C34-86E5-4C9D-8522-57A22DDCAC5F.avif'
export const TEST_VIDEO_URL: string =
  HOST + '/video/D2EEED1C-1ED3-48DD-9D5E-2D6209F8885F.mp4'
